/** Utilidades de calendario compartidas por coach y atleta. */

export function weekStart(d: Date): Date {
  const day = d.getDay(); // 0 = Dom
  const diff = day === 0 ? -6 : 1 - day; // ajusta a lunes
  const r = new Date(d);
  r.setDate(d.getDate() + diff);
  r.setHours(0, 0, 0, 0);
  return r;
}

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

/** Suma n meses a d (fija al día 1 para evitar ambigüedades en meses cortos). */
export function addMonths(d: Date, n: number): Date {
  const r = new Date(d.getFullYear(), d.getMonth() + n, 1);
  r.setHours(0, 0, 0, 0);
  return r;
}

/** Primer día del mes de d (hora 00:00:00). */
export function monthStart(d: Date): Date {
  const r = new Date(d.getFullYear(), d.getMonth(), 1);
  r.setHours(0, 0, 0, 0);
  return r;
}

/**
 * Genera una matriz de semanas (lun-dom) que cubre el mes.
 * Las celdas fuera del mes son días de relleno del mes anterior/siguiente.
 */
export function monthGrid(d: Date): Date[][] {
  const first = monthStart(d);
  const last  = new Date(first.getFullYear(), first.getMonth() + 1, 0);
  const start = weekStart(first);
  const endDow = last.getDay(); // 0 = dom
  const fillEnd = endDow === 0 ? 0 : 7 - endDow;
  const end = addDays(last, fillEnd);
  const rows: Date[][] = [];
  let cur = start;
  while (cur <= end) {
    const week: Date[] = [];
    for (let i = 0; i < 7; i++) {
      week.push(new Date(cur));
      cur = addDays(cur, 1);
    }
    rows.push(week);
  }
  return rows;
}

export function toDateStr(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function weekDays(start: Date): Date[] {
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}
